import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class TitleService {

  $title: BehaviorSubject<string> = new BehaviorSubject<string>('');
  $subtitle: BehaviorSubject<string> = new BehaviorSubject<string>('');

  routes = [
    {
      path: "/campaigns",
      title: "Your Campaigns",
      subtitle: "Search through a list of active and past campaigns."
    },
    {
      path: "/dashboard",
      title: "Your Dashboard",
      subtitle: "Your recent donations"
    },
    {
      path: "/finance",
      title: "Finance Dashboard",
      subtitle: "View all of your payments, refunds and fees paid"
    },
    {
      path: "/campaigns/create",
      title: "Create Campaign",
      subtitle: "Create a new campaign page so you can collect donations."
    },
    {
      path: "/events",
      title: "Charity Events",
      subtitle: "Organise fundraising events and sell tickets"
    },
    {
      path: "/events/create",
      title: "Create Events",
      subtitle: "Create a new event page so you can advertise and sell tickets"
    },
    {
      path: "/events/*",
      title: "",
      subtitle: ""
    },
    {
      path: "/campaigns/*",
      title: "",
      subtitle: ""
    },
    {
      path: "/donations",
      title: "Donations",
      subtitle: "Viewing all donations across all brands and campaigns"
    },
    {
      path: "/donors",
      title: "Donors",
      subtitle: "Viewing everyone who has ever donated through QR Pay"
    },
    {
      path: "/admin/brands",
      title: "Your Charity Brands",
      subtitle: "Manage your charity brand(s), click on a brand to view it's settings."
    },
    {
      path: "/admin/users",
      title: "Your Team",
      subtitle: "Manage your teams user access."
    },
    {
      path: "/admin/users/invitations",
      title: "Your Team",
      subtitle: "Manage your teams user access."
    },
    {
      path: "/admin/brands/create",
      title: "Charity Brand Setup",
      subtitle: "Create your charity brand to accept payments."
    },
    {
      path: "/admin/brands/created/*",
      title: "Connect your bank account",
      subtitle: "Complete the payment on-boarding steps required to take payments."
    },
    {
      path: "/admin/brands/onboarding/*",
      title: " ",
      subtitle: " "
    },
    {
      path: "/admin/brands/*",
      title: "",
      subtitle: ""
    },
    {
      path: "/admin/billing",
      title: "Payment Settings",
      subtitle: "Change or cancel your plan, update your billing method or download your invoices."
    },
    {
      path: "/donors/*",
      title: "",
      subtitle: ""
    },
  ]

  constructor() { }

  findItem(route: string){

    const findExact = this.routes.find((item) => item.path === route);

    if(findExact){
      return findExact;
    }

    const components = route.split('/');
    const detectGUID = components.reverse()[0].split('-').length === 5;
    if(detectGUID){
      components[0] = '*'
      components.reverse();
      const newRoute = components.join('/');
      const findGuid = this.routes.find((item) => item.path === newRoute);
      if(findGuid){
        return findGuid;
      }
    }

    return {
      path: "",
      title: "",
      subtitle: ""
    };

  }

  formatAddress(address: any){

    let addressString = '';
    let firstFieldFound = false;

    let i = 0;
    for (const [index, [key, value]] of Object.entries(Object.entries(address))) {

      if(firstFieldFound && value){

        i++;

        if(!this.isOdd((i)) && (i) > 0){
          addressString += ', <br/>';

        }else{
          addressString += ', ';
        }

      }

      if(value){

        if(key === 'postcode'){
          addressString += (value as any).toUpperCase();
        }else{
          addressString += this.toTitleCase((value as any));
        }

        firstFieldFound = true;
      }

    }

    return addressString;

  }

  isOdd(num: number) { return num % 2;}

  toTitleCase(str: string) {
    return str.replace(
      /\w\S*/g,
      function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
  }


}
